export default __webpack_public_path__ + "static/media/yfi.77a82d91.svg";